import React, { FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../app/hooks/hooks";
import { postData } from "../../../configMap/utils/entityUtils";
import documentIdsSelector from "../../selectors/documentIdsSelector";
import selectAnnotationReducer from "../../../annotation/selectors/annotationReducerSelector";
import ConfirmationModal from "../../../common/modals/confirmationModal/ConfirmationModal";

type Props = {
  setOpenModal: (open: boolean) => void;
  isNextDocument: boolean | undefined;
  openModal: boolean;
  proceed: () => void;
};

const ChangesFoundWhileNavigatingModal: FC<Props> = ({
  setOpenModal,
  isNextDocument,
  openModal,
  proceed,
}) => {
  const { t } = useTranslation("detail");

  const annotations = useAppSelector(selectAnnotationReducer);
  const { categorizationAnnotations } = useAppSelector(
    (state) => state.metadataReducer.categorizationState,
  );
  const documentIds = useAppSelector(documentIdsSelector);

  const saveChangesAndProceed = useCallback(async () => {
    setOpenModal(false);
    await postData(documentIds, annotations, categorizationAnnotations || []);
    proceed();
  }, [
    setOpenModal,
    documentIds,
    annotations,
    categorizationAnnotations,
    proceed,
  ]);

  return (
    <ConfirmationModal
      open={openModal}
      onCancel={proceed}
      onClose={() => setOpenModal(false)}
      onConfirm={saveChangesAndProceed}
      title={t("controlsNavigationHeader.changesFoundModal.title").replace(
        "$KEY",
        isNextDocument
          ? t("controlsNavigationHeader.next")
          : t("controlsNavigationHeader.previous"),
      )}
      description={t("modal.description")}
      confirmText={t("modal.leaveSave")}
      cancelText={t("modal.leave")}
      type="warning"
    />
  );
};

export default ChangesFoundWhileNavigatingModal;
